(function () {
  "use strict";
  var REQ_URL = "/pages/your-request", DUR = 8000;

  function hooks() {
    if (!document.getElementById("reqPage") || document.getElementById("rFind")) return;
    var d = document.createElement("div");
    d.hidden = true;
    d.setAttribute("aria-hidden", "true");
    d.innerHTML = '<input id="rFind" type="search" tabindex="-1" autocomplete="off"><button id="rFindClr" type="button" tabindex="-1" hidden></button><div id="rHits"></div>';
    (document.getElementById("rvaCat") || document.body).appendChild(d);
  }
  hooks();

  var CSS =
    "#rvaDrop{position:fixed;z-index:10050;top:80px;right:16px;width:360px;max-width:calc(100vw - 24px);box-sizing:border-box;" +
    "background:#fff;color:#3f0d1b;border:1px solid #eedfe1;border-radius:10px;" +
    "box-shadow:0 2px 6px rgba(63,13,27,.07),0 22px 48px rgba(63,13,27,.16);font-family:var(--f,\"Archivo\",\"Helvetica Neue\",Arial,sans-serif);" +
    "opacity:0;transform:translateY(-8px);transition:opacity .22s cubic-bezier(.16,1,.3,1),transform .22s cubic-bezier(.16,1,.3,1);pointer-events:none;text-align:left}" +
    "#rvaDrop.on{opacity:1;transform:none;pointer-events:auto}" +
    "#rvaDrop[hidden]{display:none}" +
    "#rvaDrop::before{content:\"\";position:absolute;top:-7px;left:var(--caret,calc(100% - 28px));width:12px;height:12px;margin-left:-6px;" +
    "background:#fff;border-left:1px solid #eedfe1;border-top:1px solid #eedfe1;transform:rotate(45deg);border-radius:2px 0 0 0}" +
    "#rvaDrop.noCaret::before{display:none}" +
    "#rvaDrop .rdIn{position:relative;padding:14px 16px 24px;border-radius:10px;overflow:hidden}" +
    "#rvaDrop .rdIn::after{content:\"\";position:absolute;left:0;right:0;bottom:0;height:8px;background:var(--line-2,#e8e8ed)}" +
    "#rvaDrop .rdHead{display:flex;align-items:center;gap:9px;margin:0 0 12px;font-size:14.5px;font-weight:800;letter-spacing:-.01em;line-height:1.2;color:#3f0d1b}" +
    "#rvaDrop .rdTick{flex:none;display:grid;place-items:center;width:22px;height:22px;border-radius:50%;background:#e5252e;color:#fff}" +
    "#rvaDrop .rdTick svg{width:13px;height:13px}" +
    "#rvaDrop .rdX{margin:-4px -6px -4px auto;width:32px;height:32px;display:grid;place-items:center;border:0;background:none;border-radius:6px;" +
    "color:#8b6671;font:400 24px/1 Arial,sans-serif;cursor:pointer;padding:0}" +
    "#rvaDrop .rdX:hover{background:#fbf5f4;color:#3f0d1b}" +
    "#rvaDrop .rdItem{display:flex;align-items:center;gap:12px;padding:10px;border-radius:8px;background:#fbf5f4}" +
    "#rvaDrop .rdPic{flex:none;width:58px;height:58px;border-radius:6px;overflow:hidden;background:#fff;display:grid;place-items:center}" +
    "#rvaDrop .rdPic img,#rvaDrop .rdPic svg{width:100%;height:100%;object-fit:contain;display:block}" +
    "#rvaDrop .rdTxt{min-width:0;display:flex;flex-direction:column;gap:3px;font-size:13.5px;line-height:1.3;color:#6b4351}" +
    "#rvaDrop .rdTxt b{font-size:15px;font-weight:800;color:#3f0d1b;letter-spacing:-.01em}" +
    "#rvaDrop .rdSum{display:flex;justify-content:space-between;align-items:baseline;gap:10px;margin:12px 2px 0;font-size:13.5px;line-height:1.3;color:#6b4351}" +
    "#rvaDrop .rdSum b{font-weight:800;color:#3f0d1b;font-variant-numeric:tabular-nums}" +
    "#rvaDrop .rdMin{margin:8px 2px 0;font-size:12.5px;line-height:1.4;font-weight:700;color:#b8151e}" +
    "#rvaDrop .rdBtns{display:flex;align-items:center;gap:16px;margin-top:14px}" +
    "#rvaDrop .rdGo{flex:1 1 auto;display:flex;align-items:center;justify-content:center;height:46px;padding:0 18px;border-radius:6px;" +
    "background:#e5252e;color:#fff;font-size:15px;font-weight:700;letter-spacing:-.005em;text-decoration:none;transition:background-color .2s}" +
    "#rvaDrop .rdGo:hover,#rvaDrop .rdGo:focus-visible{background:#b8151e;color:#fff}" +
    "#rvaDrop .rdKeep{flex:none;border:0;background:none;padding:6px 2px;color:#3f0d1b;font:inherit;font-size:14px;font-weight:700;" +
    "text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:4px;text-decoration-color:#ffb7ab;cursor:pointer}" +
    "#rvaDrop .rdKeep:hover{text-decoration-color:#e5252e}" +
    "#rvaDrop .rdTime{position:absolute;z-index:1;left:0;bottom:0;width:100%;height:8px;background:var(--red,#0071e3);transform-origin:0 50%;" +
    "animation:rvaDropTime var(--dur,8s) linear forwards}" +
    "#rvaDrop.held .rdTime{animation-play-state:paused}" +
    "@keyframes rvaDropTime{from{transform:scaleX(1)}to{transform:scaleX(0)}}" +
    "@media (max-width:749px){#rvaDrop{left:12px;right:12px;width:auto}}" +
    "#cart-icon-bubble.rvaBump{animation:rvaBump .6s cubic-bezier(.16,1,.3,1)}" +
    "@keyframes rvaBump{0%{transform:scale(1)}35%{transform:scale(1.18)}100%{transform:scale(1)}}" +
    "#rvaCat .addToast{display:none!important}" +
    "@media (prefers-reduced-motion:reduce){#rvaDrop{transition:none}#rvaDrop .rdTime,#rvaDrop .rdIn::after{display:none}#cart-icon-bubble.rvaBump{animation:none}}";

  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var box = null, timer = null, deadline = 0, left = 0, open = false, held = false, lastDraft = {};

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function money(n) { return typeof window.money === "function" ? window.money(n) : "$" + (+n || 0).toFixed(2); }

  function build() {
    if (box) return box;
    var st = document.createElement("style");
    st.id = "rvaDropCss";
    st.textContent = CSS;
    document.head.appendChild(st);
    box = document.createElement("div");
    box.id = "rvaDrop";
    box.hidden = true;
    box.setAttribute("role", "status");
    box.setAttribute("aria-live", "polite");
    document.body.appendChild(box);
    box.addEventListener("click", function (e) {
      if (e.target.closest(".rdX") || e.target.closest(".rdKeep")) hide();
    });
    box.addEventListener("mouseenter", hold);
    box.addEventListener("mouseleave", release);
    box.addEventListener("focusin", hold);
    box.addEventListener("focusout", function (e) { if (!box.contains(e.relatedTarget)) release(); });
    document.addEventListener("keydown", function (e) { if (open && e.key === "Escape") hide(); });
    window.addEventListener("resize", function () { if (open) place(); });
    window.addEventListener("scroll", function () { if (open) place(); }, { passive: true });
    return box;
  }

  function place() {
    var icon = document.getElementById("cart-icon-bubble");
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var r = icon && icon.getBoundingClientRect();
    var ok = !!(r && r.width > 0 && r.bottom > 0 && r.top < 220);
    box.style.top = (ok ? Math.round(r.bottom + 10) : 12) + "px";
    if (vw < 750) { box.style.left = ""; box.style.right = ""; }
    else { box.style.left = "auto"; box.style.right = (ok ? Math.max(12, Math.round(vw - r.right - 6)) : 16) + "px"; }
    var b = box.getBoundingClientRect();
    var cx = ok ? r.left + r.width / 2 - b.left : b.width - 28;
    box.style.setProperty("--caret", Math.round(Math.max(18, Math.min(b.width - 18, cx))) + "px");
    box.classList.toggle("noCaret", !ok);
  }

  function arm(ms) {
    clearTimeout(timer);
    deadline = Date.now() + ms;
    timer = setTimeout(hide, ms);
  }
  function hold() {
    if (!open || held) return;
    held = true;
    left = Math.max(0, deadline - Date.now());
    clearTimeout(timer);
    box.classList.add("held");
  }
  function release() {
    if (!open || !held) return;
    held = false;
    box.classList.remove("held");
    arm(Math.max(left, 1200));
  }
  function hide() {
    if (!box || !open) return;
    open = false;
    held = false;
    clearTimeout(timer);
    box.classList.remove("on", "held");
    setTimeout(function () { if (!open) box.hidden = true; }, 240);
  }

  function sizesText(d) {
    var order = window.SIZES || ["S", "M", "L", "XL", "2XL", "3XL"], word = window.SIZE_WORD || {}, out = [];
    order.forEach(function (z) { if (d && d[z]) out.push(d[z] + " " + (word[z] || z)); });
    return out.join(", ");
  }

  function show(pieces, style, color, draft) {
    build();
    var n = 0, total = 0;
    try { n = window.reqPieces(); } catch (e) {}
    try { total = window.reqTotal(); } catch (e) {}
    var pic = "";
    try { pic = window.photo(style, color, "rdPh"); } catch (e) {}
    var min = window.MIN_PIECES || 12;
    var sz = sizesText(draft) || (pieces + (pieces === 1 ? " piece" : " pieces"));
    box.innerHTML =
      '<div class="rdIn">' +
      '<div class="rdHead"><span class="rdTick">' + TICK + '</span><span>Added to your request</span>' +
      '<button class="rdX" type="button" aria-label="Close">&times;</button></div>' +
      '<div class="rdItem"><span class="rdPic">' + pic + '</span><span class="rdTxt"><b>' + esc(style.b + " " + style.s) + "</b>" +
      "<span>" + esc(color && color[0]) + "</span><span>" + esc(sz) + "</span></span></div>" +
      '<div class="rdSum"><span>Your request: <b>' + n + (n === 1 ? " piece" : " pieces") + "</b></span><span><b>" + money(total) + "</b> before tax</span></div>" +
      (n < min ? '<p class="rdMin">' + min + "-piece minimum for the whole order. Add " + (min - n) + " more in any size, color or style.</p>" : "") +
      '<div class="rdBtns"><a class="rdGo" href="' + REQ_URL + '">View request &amp; send</a><button class="rdKeep" type="button">Keep shopping</button></div>' +
      '<span class="rdTime" style="--dur:' + DUR / 1000 + 's"></span></div>';
    box.hidden = false;
    held = false;
    box.classList.remove("held");
    place();
    void box.offsetWidth;
    box.classList.add("on");
    open = true;
    arm(DUR);
    var icon = document.getElementById("cart-icon-bubble");
    if (icon) { icon.classList.remove("rvaBump"); void icon.offsetWidth; icon.classList.add("rvaBump"); }
  }

  function persist() {
    try { window.saveReq(); } catch (e) {}
    try { window.syncDock(); } catch (e) {}
  }

  function exactBadge() {
    var sync = window.syncCartIcon;
    if (typeof sync !== "function" || sync.rvaExact) return;
    var exact = function (n) {
      var r = sync.apply(this, arguments);
      var s = n ? document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]') : null;
      if (s) s.textContent = n;
      return r;
    };
    exact.rvaExact = 1;
    window.syncCartIcon = exact;
    try { window.syncDock(); } catch (e) {}
  }

  function ready() {
    return window.S && typeof window.addToRequest === "function" && typeof window.saveReq === "function" && typeof window.showAddToast === "function";
  }
  function start() {
    if (!ready()) return false;
    if (window.addToRequest.rvaDrop) return true;
    var add = window.addToRequest;
    var wrapped = function () {
      try { lastDraft = JSON.parse(JSON.stringify(window.S.draft || {})); } catch (e) { lastDraft = {}; }
      var r = add.apply(this, arguments);
      persist();
      return r;
    };
    wrapped.rvaDrop = 1;
    window.addToRequest = wrapped;
    window.showAddToast = function (pieces, style, color) {
      persist();
      try { show(pieces, style, color, lastDraft); } catch (e) {}
    };
    window.showAddToast.rvaDrop = 1;
    exactBadge();
    return true;
  }
  if (!start()) {
    var tries = 0, iv = setInterval(function () { if (start() || ++tries > 200) clearInterval(iv); }, 50);
  }
})();